import {sizeOf} from '../sizeOf';

export function parseQuery(url: UrlString): MaybeNull<Dict<string>> {
  const result: Dict<string> = {};

  new URL(url).searchParams.forEach((value, key) => {
    result[key] = value;
  });

  return sizeOf(result) ? result : null;
}
